export default "__VITE_ASSET__2lkBNoD6__"